import script from "./WorksiteInspectionCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./WorksiteInspectionCompleted.vue?vue&type=script&setup=true&lang=js"

import "./WorksiteInspectionCompleted.vue?vue&type=style&index=0&id=b23dbb66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b23dbb66"]])

export default __exports__